import { Stack } from "@mantine/core";
import { Box } from "../box";
import styles from "./content.module.scss";
import type { IProps, IHeaderProps, IBodyProps, IFooterProps } from "./content.types";
import classnames from "classnames";

const Content = (props: IProps) => {
    return (
        <Box className={styles["container"]} {...props}>
            <Stack gap={0}>{props.children}</Stack>
        </Box>
    );
};

const ContentHeader = ({ className, ...other }: IHeaderProps) => {
    return <Box className={classnames(className, styles["header"])} {...other} />;
};

const ContentBody = ({ className, ...other }: IBodyProps) => {
    return <Box className={classnames(className, styles["body"])} {...other} />;
};

const ContentFooter = ({ className, ...other }: IFooterProps) => {
    return <Box className={classnames(className, styles["footer"])} {...other} />;
};

Content.Header = ContentHeader;
Content.Body = ContentBody;
Content.Footer = ContentFooter;

export { Content };
